module.exports = __webpack_public_path__ + "static/media/AddUser.02a71f15.svg";